module.exports = __webpack_public_path__ + "static/media/home.18a5df2b.svg";